import type { OrderCheckoutFormData } from './OrderCheckoutSummary';

type BuildExtras = {
  source?: string;
  credit_card_token?: string;
  purchase_order_token?: string; // optional override
};

export function buildSendToReviewPayloadFromOrderForm(
  form: OrderCheckoutFormData,
  extras?: BuildExtras
) {
  const isCreditCard = form.paymentMethod === 'credit_card';

  const token =
    isCreditCard
      ? (extras?.credit_card_token ?? null)
      : (extras?.purchase_order_token ?? 'PURCHASE_ORDER');

  return {
    source: extras?.source ?? 'Order Checkout - Customer',

    pay_with_credit_card: isCreditCard,
    credit_card_token: token,

    phone: form.phone,
    email: form.email,

    shipping_address_id: form.shippingAddressId ?? null,
    billing_address_id: form.billingSameAsShipping
      ? form.shippingAddressId ?? null
      : form.billingAddressId ?? null,

    carrier: form.carrier ?? null,
    shipping_method: form.shippingMethod ?? null,
    shipping_account_number: form.shippingAccountNumber ?? null,

    save_shipping_defaults: !!form.saveShippingDefaults,

    po_files: (form.purchaseOrderInfo?.poFiles ?? [])
      .map((f: any) => f?.response?.id ?? f?.id)
      .filter(Boolean),
  };
}
